var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge-base LI-profile-badge",attrs:{"data-locale":"en_US","data-size":"large","data-theme":"light","data-type":"HORIZONTAL","data-vanity":"eric-de-groot-82ab10211","data-version":"v1"}})}
var staticRenderFns = []

export { render, staticRenderFns }